let counter = 0;

/** Deterministic, session-scoped id generator (no crypto dependency in the kernel). */
export function nextId(prefix = 'e'): string {
  counter += 1;
  return `${prefix}${counter.toString(36)}`;
}

export function resetIdCounter(value = 0): void {
  counter = value;
}
